import React from 'react'

const Management = () => {
  return (
    <div>
      <div className='subpages_heading'></div>
      <div className='subpages_body'></div>
    </div>
  )
}

export default Management
